<fc-general-modal
    [baseId]="baseId"
    [form]="form"
    [fcModalItemContext]="fcModalItemContext"
    (saveForm)="save()"
    (cancelForm)="onCancel()">
  <div [formGroup]="form">
    <mat-tab-group animationDuration="0ms" mat-align-tabs="start" class="tabs-default full-modal-tabs" [disableRipple]="true">
      <mat-tab>
        <ng-template mat-tab-label>
          <span class="tab-label" translate>General</span>
          <mat-badge
            *ngIf="getFormValidationErrors(generalGroup) as errorCount"
            [matBadge]="errorCount"
            matBadgeColor="warn"
            matBadgeSize="small"
            matBadgePosition="after"
          ></mat-badge>
        </ng-template>
        <fc-patient-program-general-tab
          [baseId]="baseId"
          [isDataLoaded]="isDataLoaded"
          [form]="generalGroup"
          [listItem]="listItem"
          [isSubmitted]="isSubmitted"
          [itemContext]="fcModalItemContext"
        >
        </fc-patient-program-general-tab>
      </mat-tab>
      <mat-tab [disabled]="isTabDisabled">
        <ng-template mat-tab-label>
          <span class="tab-label" translate>Facility Portal Access</span>
          <mat-badge
            *ngIf="getFormValidationErrors(facilityPortalAccessGroup) as errorCount"
            [matBadge]="errorCount"
            matBadgeColor="warn"
            matBadgeSize="small"
            matBadgePosition="after"
          ></mat-badge>
        </ng-template>
        <fc-facility-portal-access-list
          [baseId]="baseId"
          [isDataLoaded]="isDataLoaded"
          [form]="facilityPortalAccessGroup"
          [listItem]="listItem.RelPatientProgramPersonWeb"
          [isSubmitted]="isSubmitted"
          [itemContext]="fcModalItemContext"
        >
        </fc-facility-portal-access-list>
      </mat-tab>
    </mat-tab-group>
  </div>
</fc-general-modal>
